import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, DialogDescription, Heading, Modal, ModalBody, ModalFooter, ModalTitle, Portal, Tabs, TabsBar, TabsPanel, useToast } from "@vertesia/ui/core";
import { useUserSession } from "@vertesia/ui/session";
import { useCallback, useState } from "react";
import { useUITranslation } from '../../../../../i18n/index.js';
import { i18nInstance, NAMESPACE } from '../../../../../i18n/instance.js';
import { CreateCollectionForm, SelectCollection } from "../../../collections";
import { useObjectsActionCallback } from "../ObjectsActionHooks";
export function AddToCollectionActionComponent({ action, objectIds }) {
    const [showModal, setShowModal] = useState(false);
    const callback = useCallback(() => {
        if (objectIds.length > 0) {
            setShowModal(true);
        }
        return Promise.resolve(true);
    }, [objectIds]);
    const onClose = () => {
        setShowModal(false);
    };
    useObjectsActionCallback(action.id, callback);
    return showModal && _jsx(Portal, { children: _jsx(SelectCollectionModal, { objectIds: objectIds, isOpen: showModal, onClose: onClose }) });
}
const t = i18nInstance.getFixedT(null, NAMESPACE);
export const AddToCollectionAction = {
    id: "addToCollection",
    name: t('store.actions.addToCollection'),
    description: t('store.actions.addToCollectionDesc'),
    confirm: false,
    component: AddToCollectionActionComponent,
};
function SelectCollectionModal({ isOpen, onClose, objectIds }) {
    const { t } = useUITranslation();
    return (_jsxs(Modal, { isOpen: isOpen, onClose: onClose, className: "max-w-lg w-full min-w-0 overflow-hidden", children: [_jsx(ModalTitle, { className: "flex flex-col min-w-0 overflow-hidden", children: t('store.actions.addToCollectionTitle') }), _jsx(DialogDescription, { className: "min-w-0 overflow-hidden", children: t('store.actions.addToCollectionBody') }), _jsx("div", { className: "min-w-0 max-w-full overflow-hidden", children: _jsx(AddToCollectionForm, { onClose: onClose, objectIds: objectIds }) })] }));
}
function AddToCollectionForm({ onClose, objectIds }) {
    const { t } = useUITranslation();
    const toast = useToast();
    const { client } = useUserSession();
    const [selectedCollectionId, setSelectedCollectionId] = useState();
    const onAddToCollection = ({ collectionId }) => {
        if (!collectionId || !objectIds?.length) {
            return;
        }
        client.store.collections.addMembers(collectionId, objectIds).then(() => {
            toast({
                title: t('store.actions.addToCollectionSuccess'),
                status: 'success',
                description: t('store.actions.addToCollectionSuccessDesc', { count: objectIds.length }),
                duration: 3000
            });
            onClose();
        }).catch(() => {
            toast({
                title: t('store.actions.addToCollectionFailure'),
                status: 'error',
                description: t('store.actions.addToCollectionFailureDesc'),
                duration: 5000
            });
        });
    };
    const onCollectionChange = (collectionId, _collection) => {
        if (typeof collectionId === "string" || typeof collectionId === "undefined") {
            setSelectedCollectionId(collectionId);
        }
        else if (Array.isArray(collectionId) && collectionId.length > 0) {
            setSelectedCollectionId(collectionId[0]);
        }
        else {
            setSelectedCollectionId(undefined);
        }
    };
    const tabs = [
        {
            name: 'select',
            label: t('store.actions.selectCollection'),
            content: (_jsxs("div", { className: "p-4 min-w-0 max-w-full overflow-hidden", children: [_jsx(Heading, { level: 5, children: t('store.actions.chooseExistingCollections') }), _jsx(ModalBody, { className: "min-w-0 max-w-full overflow-hidden", children: _jsx("div", { className: "mb-4 min-w-0 max-w-full overflow-hidden", children: _jsx(SelectCollection, { onChange: onCollectionChange, value: selectedCollectionId }) }) }), _jsx(ModalFooter, { children: _jsx(Button, { isDisabled: !selectedCollectionId, onClick: () => selectedCollectionId && onAddToCollection({ collectionId: selectedCollectionId }), children: t('store.actions.addToCollectionButton') }) })] }))
        },
        {
            name: 'create',
            label: t('store.actions.createNew'),
            content: _jsx("div", { className: "p-4", children: _jsx(CreateCollectionForm, { onClose: onClose, onAddToCollection: (id) => onAddToCollection({ collectionId: id }), redirect: false }) })
        }
    ];
    return (_jsxs(Tabs, { defaultValue: "select", tabs: tabs, fullWidth: true, children: [_jsx(TabsBar, {}), _jsx(TabsPanel, {})] }));
}
//# sourceMappingURL=AddToCollectionAction.js.map